import { IIconProps } from './icon';

export const IconDialogue = ({ style = {}, cy }: IIconProps) => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="#515252"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      data-cy={`IconDialogue${cy}`}
    >
      <path d="M12.3333 0.833252H1.66668C0.933344 0.833252 0.34001 1.43325 0.34001 2.16659L0.333344 14.1666L3.00001 11.4999H12.3333C13.0667 11.4999 13.6667 10.8999 13.6667 10.1666V2.16659C13.6667 1.43325 13.0667 0.833252 12.3333 0.833252ZM3.00001 5.49992H11V6.83325H3.00001V5.49992ZM8.33334 8.83325H3.00001V7.49992H8.33334V8.83325ZM11 4.83325H3.00001V3.49992H11V4.83325Z" />
    </svg>
  );
};
